interface IQueryLoadingState {
	isLoading: boolean;
	isPreviousData: boolean;
	isStale: boolean;
	isRefetching: boolean;
}

export const isQueryLoading = (query: IQueryLoadingState): boolean =>
	query.isLoading || query.isPreviousData || (query.isStale && query.isRefetching);
